import React from "react";
import ReactDOM from "react-dom"
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { projectName } from '../../../../config';
import { shortProjectName } from '../../../config';
import { ThreeDots } from '../common/Placeholders.jsx';
import notifier from '../../../_utils/notifier';

let PayPalButton = null;
try {
  PayPalButton = paypal.Buttons.driver("react", { React, ReactDOM });
} catch (e){

}

const PaypalWidgetComponent = ({ first_name, last_name, email,
                                 offer, payment, onBuyApprove}) => {
  const createOrder = (data, actions) =>{
    if (payment){
      return actions.order.create({
        intent: "CAPTURE",
        payer: {
          name: {
            given_name: first_name,
            surname: last_name
          },
          email_address: email,
        },
        application_context: {
          brand_name: projectName,
          landing_page: "BILLING",
          shipping_preference: "NO_SHIPPING",
          user_action: "PAY_NOW"
        },

        purchase_units: [
          {
            description: gettext('Заказ') + ' №' + payment.id  + '.'
                         + offer + ' ' + gettext('на') + ' ' + projectName +'.',
            soft_descriptor: shortProjectName,
            amount: {
              currency_code: payment.currency,
              value: payment.price,
              breakdown: {
                item_total: {
                  currency_code: payment.currency,
                  value: payment.price,
                }
              }
            },
            items: [
              {
                name: gettext('Заказ') + ' №' + payment.id,
                sku: 'sku' + payment.id,
                  unit_amount: {
                    currency_code: payment.currency,
                    value: payment.price,
                  },
                quantity: "1",
              }
            ]
          },
        ],
      });
    }
  };

  const onApprove = (data, actions) => {
    notifier.success(gettext('Процес оплаты прошел успешно. Файлы будут доступны для скачивания как только платеж будет проведен.'));
    onBuyApprove();
    return actions.order.capture();
  };

  const onError = (err) => {
    console.error(err);
    notifier.danger(gettext('Во время оплаты произошла ошибка, обновите страницу и попробуйте еще раз.'));
  }

  if (PayPalButton) {
    return (
      <PayPalButton
        createOrder={(data, actions) => createOrder(data, actions)}
        onApprove={(data, actions) => onApprove(data, actions)}
        onError={(err) => onError(err)}
      />
    );
  }
}

PaypalWidgetComponent.propTypes = {
  first_name: PropTypes.string.isRequired,
  last_name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  offer: PropTypes.string.isRequired,
  payment: PropTypes.shape({
    id: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
  }).isRequired,
  onBuyApprove: PropTypes.func.isRequired,
}

let mapStateToProps = (state) => {
  return {
    first_name: state.auth.first_name,
    last_name: state.auth.last_name,
    email: state.auth.email,
  }
};

export default compose(
  connect(mapStateToProps, {}),
)(PaypalWidgetComponent);
